export const dateAndTime = {
  filters: {
    setDateAndTime (time) {
      const dateTime = new Date(time * 1000)
      return `${dateTime.toLocaleDateString()} ${dateTime.toLocaleTimeString()}`
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/dateAndTime.js